export enum DIRECTION {
  UP = 'up',
  DOWN = 'down',
}
